import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'
import kubun from 'config/kubun.json'

export const OenKanoKbn = props => {
  const options = kubun.oen_kano_kbn

  return <Dropdown.Standard options={options} {...props} />
}
